const COMPLETED_EVENT_NAMES = new Set(["query complete", "completed"]);

export const shouldShowSearchComplete = ({
  status,
  sseEventName,
  logId,
  queryCompleteData,
}) =>
  status === "waiting" &&
  COMPLETED_EVENT_NAMES.has(String(sseEventName || "").toLowerCase()) &&
  Boolean(logId) &&
  Boolean(queryCompleteData);
